var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-title"},[_c('img',{attrs:{"src":"/images/news/title1.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title)+"   ")]),_vm._v(" "),_c('img',{attrs:{"src":"/images/news/title2.png","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }